import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { Prompt, Route, useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { APIIssueTrigger } from '../../../../../../../../typings/IssueTrigger.interface';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { capitalizeFirstLetter } from '../../../../../utils';
import field_formats from '../../../../../utils/field-formatters';
import { issue_actions, issue_type_configs } from '../../../../../utils/issues';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import Icon from '../../../../common/base/Icon';
import Loading from '../../../../common/base/Loading';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import TextSwitch from '../../../../common/base/TextSwitch';
import { useDialog } from '../../../../common/Dialog';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { TeamPermission } from '../../../../contexts/TeamPermissionContext';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, StyledViewSplitPaneContent, StyledViewSplitPaneLayout, StyledViewSplitPaneSection, StyledViewSplitPaneSidebar, StyledViewSplitPaneSidebarBody, ViewBreadcrumbsTitle, ViewMetadataCopyable, ViewMetadataDate, ViewMetadataItem, ViewSplitPaneSidebarHeader, ViewSplitPaneSidebarSection } from '../../../../layouts/ViewLayout';
import { DashboardContext } from '../../DashboardContext';
import IssuesList, { useIssuesList } from '../../Issues/IssueList';
import NotFound from '../../NotFound';
import issue_trigger_forms from '../IssueTriggersList/Forms/IssueTriggersForms';
const IssueTriggerView: React.FC = () => {
  const $ = _c(151);
  const {
    id: issue_trigger_id
  } = useParams();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    is_degraded_banner_active
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const history = useHistory();
  let t0;
  if ($[0] !== issue_trigger_id) {
    t0 = APIMethodKeys.issue_triggers.get(issue_trigger_id);
    $[0] = issue_trigger_id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== HookdeckAPI.issue_triggers || $[3] !== issue_trigger_id) {
    t1 = () => HookdeckAPI.issue_triggers.get(issue_trigger_id);
    $[2] = HookdeckAPI.issue_triggers;
    $[3] = issue_trigger_id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: issue_trigger,
    error,
    mutate
  } = useSWR(t0, t1);
  let t2;
  if ($[5] !== issue_trigger_id) {
    t2 = APIMethodKeys.issues.count({
      issue_trigger_id
    });
    $[5] = issue_trigger_id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== HookdeckAPI.issues || $[8] !== issue_trigger_id) {
    t3 = () => HookdeckAPI.issues.count({
      issue_trigger_id
    });
    $[7] = HookdeckAPI.issues;
    $[8] = issue_trigger_id;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    data: issue_count,
    mutate: mutateCount
  } = useSWR(t2, t3);
  let t4;
  if ($[10] !== mutateCount) {
    t4 = async action => {
      mutateCount();
    };
    $[10] = mutateCount;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onIssueAction = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = APIMethodKeys.team_integrations.list();
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== HookdeckAPI.team_integrations) {
    t6 = () => HookdeckAPI.team_integrations.list();
    $[13] = HookdeckAPI.team_integrations;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    data: integrations
  } = useSWR(t5, t6);
  const {
    issues_pages,
    mutateIssuesPages
  } = useIssuesList(undefined, undefined, "first_seen_at", issue_trigger_id);
  if (error && error.response?.status === 404) {
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        to: "/issue-triggers",
        text: "All Triggers"
      };
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== issue_trigger_id) {
      t8 = <NotFound title="Issue trigger not found" description="This issue trigger has been deleted or does not exist within this project." id={issue_trigger_id} link={t7} />;
      $[16] = issue_trigger_id;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    return t8;
  }
  if (!issue_trigger || integrations === undefined) {
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Div flex={{
        justify: "center",
        align: "center"
      }} h={{
        vh: 100
      }}><Loading /></Div>;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    return t7;
  }
  let t7;
  if ($[19] !== HookdeckAPI.issue_triggers || $[20] !== addToast || $[21] !== history || $[22] !== issue_trigger.id || $[23] !== showDialog) {
    t7 = () => {
      showDialog(() => {
        HookdeckAPI.issue_triggers.delete(issue_trigger.id).then(() => {
          addToast("success", "Issue trigger has been deleted.");
          history.push("/issue-triggers");
        }).catch(() => {
          addToast("error", "Issue trigger could not be deleted.");
        });
      }, _temp, {
        title: "Delete issue trigger",
        message: "All triggered issues will also be deleted. Are you sure?",
        danger: true,
        submit_label: "Delete trigger",
        cancel_label: "Cancel"
      });
    };
    $[19] = HookdeckAPI.issue_triggers;
    $[20] = addToast;
    $[21] = history;
    $[22] = issue_trigger.id;
    $[23] = showDialog;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const onDelete = t7;
  const {
    Fields,
    getInitialValues,
    formatValuesToAPIInput,
    validate
  } = issue_trigger_forms[issue_trigger.type];
  let t8;
  if ($[25] !== getInitialValues || $[26] !== integrations.models || $[27] !== issue_trigger) {
    t8 = getInitialValues(integrations.models, issue_trigger);
    $[25] = getInitialValues;
    $[26] = integrations.models;
    $[27] = issue_trigger;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const intial_values = t8;
  const isOverviewTab = location.pathname.split("/").length === 3;
  const activeTab = isOverviewTab ? "overview" : "issues";
  let t9;
  if ($[29] !== HookdeckAPI.issues || $[30] !== addToast || $[31] !== issues_pages || $[32] !== mutateIssuesPages || $[33] !== onIssueAction) {
    t9 = async (issues_id, action_0) => {
      Promise.all(issues_id.map(id => {
        if (action_0 === "acknowledge") {
          return HookdeckAPI.issues.update(id, {
            status: "ACKNOWLEDGED"
          });
        } else {
          if (action_0 === "resolve") {
            return HookdeckAPI.issues.update(id, {
              status: "RESOLVED"
            });
          } else {
            if (action_0 === "reopen") {
              return HookdeckAPI.issues.update(id, {
                status: "OPENED"
              });
            } else {
              if (action_0 === "ignore") {
                return HookdeckAPI.issues.update(id, {
                  status: "IGNORED"
                });
              } else {
                if (action_0 === "dismiss") {
                  return HookdeckAPI.issues.dismiss(id);
                }
              }
            }
          }
        }
      })).then(updated_issues => {
        onIssueAction(action_0);
        addToast("success", "Issues status updated");
        mutateIssuesPages(issues_pages?.map(page => ({
          ...page,
          models: page.models.map(issue => updated_issues.find(updated_issue => updated_issue && updated_issue.id === issue.id) || issue)
        }), false));
      }).catch(() => addToast("error", "Failed to update issues"));
    };
    $[29] = HookdeckAPI.issues;
    $[30] = addToast;
    $[31] = issues_pages;
    $[32] = mutateIssuesPages;
    $[33] = onIssueAction;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const applyAction = t9;
  let t10;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      label: "Issue Triggers",
      to: "/issue-triggers"
    };
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== issue_trigger_id) {
    t11 = <StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={[t10, {
        label: issue_trigger_id,
        highlight: true
      }]} /></StyledViewNavHeader>;
    $[36] = issue_trigger_id;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  const t12 = `/issue-triggers/${issue_trigger_id}`;
  let t13;
  if ($[38] !== t12) {
    t13 = {
      key: "overview",
      label: "Overview",
      to: t12
    };
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  const t14 = `/issue-triggers/${issue_trigger_id}/issues`;
  const t15 = issue_count?.count || 0;
  let t16;
  if ($[40] !== t14 || $[41] !== t15) {
    t16 = {
      key: "issues",
      label: "Triggered issues",
      to: t14,
      badge_label: t15,
      badge_theme: "muted"
    };
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t13 || $[44] !== t16) {
    t17 = <StyledViewNavSecondary><Tabs active_tab={activeTab} border={false} tabs={[t13, t16]} /></StyledViewNavSecondary>;
    $[43] = t13;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t11 || $[47] !== t17) {
    t18 = <StyledViewNav>{t11}{t17}</StyledViewNav>;
    $[46] = t11;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ViewSplitPaneSidebarHeader title="Issue trigger details" />;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  const t20 = !!issue_trigger.disabled_at;
  const t21 = !issue_trigger.disabled_at;
  const t22 = issue_trigger.disabled_at ? "notification_off" : "notification";
  let t23;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      r: 1
    };
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t22) {
    t24 = <Icon icon={t22} m={t23} />;
    $[51] = t22;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  const t25 = issue_trigger.disabled_at ? "Disabled" : "Enabled";
  let t26;
  if ($[53] !== t20 || $[54] !== t21 || $[55] !== t24 || $[56] !== t25) {
    t26 = <ViewMetadataItem label="Status"><Badge subtle={true} neutral={t20} success={t21}>{t24}{t25}</Badge></ViewMetadataItem>;
    $[53] = t20;
    $[54] = t21;
    $[55] = t24;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  const t27 = issue_type_configs[issue_trigger.type];
  let t28;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      r: 1
    };
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t27.icon) {
    t29 = <Icon icon={t27.icon} m={t28} />;
    $[59] = t27.icon;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== issue_trigger.type) {
    t30 = capitalizeFirstLetter(issue_trigger.type);
    $[61] = issue_trigger.type;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t29 || $[64] !== t30) {
    t31 = <ViewMetadataItem label="Trigger type"><Badge neutral={true}>{t29}{t30}</Badge></ViewMetadataItem>;
    $[63] = t29;
    $[64] = t30;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t26 || $[67] !== t31) {
    t32 = <ViewSplitPaneSidebarSection>{t26}{t31}</ViewSplitPaneSidebarSection>;
    $[66] = t26;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== issue_trigger.id) {
    t33 = <ViewMetadataItem label="Trigger ID"><ViewMetadataCopyable value={issue_trigger.id} /></ViewMetadataItem>;
    $[69] = issue_trigger.id;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== issue_trigger.created_at) {
    t34 = <ViewMetadataItem label="Created at">{issue_trigger.created_at ? <ViewMetadataDate date={issue_trigger.created_at} /> : <Text muted={true}>–</Text>}</ViewMetadataItem>;
    $[71] = issue_trigger.created_at;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== issue_trigger.updated_at) {
    t35 = <ViewMetadataItem label="Last updated">{issue_trigger.updated_at ? <ViewMetadataDate date={issue_trigger.updated_at} /> : <Text muted={true}>–</Text>}</ViewMetadataItem>;
    $[73] = issue_trigger.updated_at;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== t33 || $[76] !== t34 || $[77] !== t35) {
    t36 = <ViewSplitPaneSidebarSection title="Metadata" bordered={true}>{t33}{t34}{t35}</ViewSplitPaneSidebarSection>;
    $[75] = t33;
    $[76] = t34;
    $[77] = t35;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  let t37;
  if ($[79] !== t32 || $[80] !== t36) {
    t37 = <StyledViewSplitPaneSidebar><StyledViewSplitPaneSidebarBody>{t19}{t32}{t36}</StyledViewSplitPaneSidebarBody></StyledViewSplitPaneSidebar>;
    $[79] = t32;
    $[80] = t36;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Text bold={true} size="l" m={{
      b: 4
    }}>Trigger behavior</Text>;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== validate) {
    t39 = async values => {
      let errors = {};
      if (validate) {
        errors = validate(values);
      }
      return errors;
    };
    $[83] = validate;
    $[84] = t39;
  } else {
    t39 = $[84];
  }
  let t40;
  if ($[85] !== HookdeckAPI.issue_triggers || $[86] !== addToast || $[87] !== formatValuesToAPIInput || $[88] !== getInitialValues || $[89] !== integrations.models || $[90] !== issue_trigger_id || $[91] !== mutate) {
    t40 = (values_0, t41) => {
      const {
        resetForm
      } = t41;
      return HookdeckAPI.issue_triggers.update(issue_trigger_id, formatValuesToAPIInput(values_0 as any)).then(issue_trigger_0 => {
        addToast("success", "Issue trigger updated");
        mutate(issue_trigger_0);
        resetForm({
          values: getInitialValues(integrations.models, issue_trigger_0),
          touched: {}
        });
        return issue_trigger_0;
      }).catch(() => {
        addToast("error", "Error updating issue trigger");
        return null;
      });
    };
    $[85] = HookdeckAPI.issue_triggers;
    $[86] = addToast;
    $[87] = formatValuesToAPIInput;
    $[88] = getInitialValues;
    $[89] = integrations.models;
    $[90] = issue_trigger_id;
    $[91] = mutate;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== Fields || $[94] !== integrations.models) {
    t41 = t42 => {
      const {
        isSubmitting,
        isValid,
        dirty
      } = t42;
      return <Form><Prompt when={!isSubmitting && dirty} message="Are you sure you want to quit without saving your work?" /><Fields integrations={integrations.models} muted={false} /><Button.Permission m={{
          t: 5
        }} disabled={isSubmitting || !isValid || !dirty} submit={true} primary={true} icon="save">Save</Button.Permission></Form>;
    };
    $[93] = Fields;
    $[94] = integrations.models;
    $[95] = t41;
  } else {
    t41 = $[95];
  }
  let t42;
  if ($[96] !== intial_values || $[97] !== t39 || $[98] !== t40 || $[99] !== t41) {
    t42 = <StyledViewSplitPaneSection max_width="medium">{t38}<Formik initialValues={intial_values} validate={t39} onSubmit={t40}>{t41}</Formik></StyledViewSplitPaneSection>;
    $[96] = intial_values;
    $[97] = t39;
    $[98] = t40;
    $[99] = t41;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Text bold={true} size="l" m={0}>Trigger name</Text>;
    $[101] = t43;
  } else {
    t43 = $[101];
  }
  let t44;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Text muted={true} m={{
      b: 4
    }}>Provide a name to programmatically query for this issue trigger within the API.</Text>;
    $[102] = t44;
  } else {
    t44 = $[102];
  }
  const t45 = issue_trigger.name || "";
  let t46;
  if ($[103] !== t45) {
    t46 = {
      name: t45
    };
    $[103] = t45;
    $[104] = t46;
  } else {
    t46 = $[104];
  }
  let t47;
  if ($[105] !== HookdeckAPI.issue_triggers || $[106] !== issue_trigger.name) {
    t47 = async values_1 => {
      const errors_0 = {};
      if (values_1.name && issue_trigger.name !== values_1.name) {
        const used = await HookdeckAPI.issue_triggers.nameIsUsed(values_1.name);
        if (used) {
          errors_0.name = "Name is already used.";
        }
      }
      return errors_0;
    };
    $[105] = HookdeckAPI.issue_triggers;
    $[106] = issue_trigger.name;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  let t48;
  if ($[108] !== HookdeckAPI.issue_triggers || $[109] !== addToast || $[110] !== issue_trigger_id || $[111] !== mutate) {
    t48 = (values_2, t49) => {
      const {
        resetForm: resetForm_0
      } = t49;
      return HookdeckAPI.issue_triggers.update(issue_trigger_id, {
        name: values_2.name || null
      }).then(issue_trigger_1 => {
        addToast("success", "Issue trigger name updated");
        mutate(issue_trigger_1);
        resetForm_0({
          values: {
            name: issue_trigger_1.name || ""
          },
          touched: {}
        });
        return issue_trigger_1;
      }).catch(() => {
        addToast("error", "Error updating issue trigger name");
        return null;
      });
    };
    $[108] = HookdeckAPI.issue_triggers;
    $[109] = addToast;
    $[110] = issue_trigger_id;
    $[111] = mutate;
    $[112] = t48;
  } else {
    t48 = $[112];
  }
  let t49;
  if ($[113] !== t46 || $[114] !== t47 || $[115] !== t48) {
    t49 = <StyledViewSplitPaneSection max_width="medium">{t43}{t44}<Formik initialValues={t46} validate={t47} onSubmit={t48}>{_temp2}</Formik></StyledViewSplitPaneSection>;
    $[113] = t46;
    $[114] = t47;
    $[115] = t48;
    $[116] = t49;
  } else {
    t49 = $[116];
  }
  let t50;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Text bold={true} size="l" m={0}>Trigger status</Text>;
    $[117] = t50;
  } else {
    t50 = $[117];
  }
  let t51;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <Text muted={true} m={{
      b: 4
    }}>Disabled triggers will not communicate any associated issues and alerts.</Text>;
    $[118] = t51;
  } else {
    t51 = $[118];
  }
  let t52;
  if ($[119] !== HookdeckAPI.issue_triggers || $[120] !== addToast || $[121] !== issue_trigger.disabled_at || $[122] !== issue_trigger_id || $[123] !== mutate) {
    t52 = key => {
      let statusPromise = null;
      if (key === "true" && issue_trigger.disabled_at) {
        statusPromise = HookdeckAPI.issue_triggers.enable(issue_trigger_id);
      } else {
        if (key === "false" && !issue_trigger.disabled_at) {
          statusPromise = HookdeckAPI.issue_triggers.disable(issue_trigger_id);
        }
      }
      if (!statusPromise) {
        return null;
      }
      return statusPromise.then(issue_trigger_2 => {
        addToast("success", `Issue trigger ${!issue_trigger_2.disabled_at ? "enabled" : "disabled"}`);
        mutate(issue_trigger_2);
        return issue_trigger_2;
      }).catch(() => {
        addToast("error", "Error updating issue trigger");
        return null;
      });
    };
    $[119] = HookdeckAPI.issue_triggers;
    $[120] = addToast;
    $[121] = issue_trigger.disabled_at;
    $[122] = issue_trigger_id;
    $[123] = mutate;
    $[124] = t52;
  } else {
    t52 = $[124];
  }
  const t53 = issue_trigger.disabled_at ? "false" : "true";
  let t54;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = [{
      key: "true",
      label: "Enabled"
    }, {
      key: "false",
      label: "Disabled"
    }];
    $[125] = t54;
  } else {
    t54 = $[125];
  }
  let t55;
  if ($[126] !== t52 || $[127] !== t53) {
    t55 = <StyledViewSplitPaneSection max_width="medium">{t50}{t51}<TextSwitch onSelect={t52} active={t53} options={t54} /></StyledViewSplitPaneSection>;
    $[126] = t52;
    $[127] = t53;
    $[128] = t55;
  } else {
    t55 = $[128];
  }
  let t56;
  if ($[129] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <Text bold={true} size="l" m={0}>Delete trigger</Text>;
    $[129] = t56;
  } else {
    t56 = $[129];
  }
  let t57;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <Text muted={true} m={{
      b: 4
    }}>Delete this trigger and all associated issues.</Text>;
    $[130] = t57;
  } else {
    t57 = $[130];
  }
  let t58;
  if ($[131] !== onDelete) {
    t58 = <StyledViewSplitPaneSection max_width="medium">{t56}{t57}<Button.Permission danger={true} outline={true} icon="delete" onClick={onDelete}>Delete trigger</Button.Permission></StyledViewSplitPaneSection>;
    $[131] = onDelete;
    $[132] = t58;
  } else {
    t58 = $[132];
  }
  let t59;
  if ($[133] !== t42 || $[134] !== t49 || $[135] !== t55 || $[136] !== t58) {
    t59 = <StyledViewSplitPaneContent>{t42}{t49}{t55}{t58}</StyledViewSplitPaneContent>;
    $[133] = t42;
    $[134] = t49;
    $[135] = t55;
    $[136] = t58;
    $[137] = t59;
  } else {
    t59 = $[137];
  }
  let t60;
  if ($[138] !== is_degraded_banner_active || $[139] !== t37 || $[140] !== t59) {
    t60 = <Route exact={true} path="/issue-triggers/:id"><StyledViewSplitPaneLayout banner_active={is_degraded_banner_active}>{t37}{t59}</StyledViewSplitPaneLayout></Route>;
    $[138] = is_degraded_banner_active;
    $[139] = t37;
    $[140] = t59;
    $[141] = t60;
  } else {
    t60 = $[141];
  }
  let t61;
  if ($[142] !== applyAction || $[143] !== issue_trigger_id) {
    t61 = <Route exact={true} path="/issue-triggers/:id/issues"><IssuesList issue_trigger_id={issue_trigger_id} group_by="status" sort_by="first_seen_at" applyAction={applyAction} /></Route>;
    $[142] = applyAction;
    $[143] = issue_trigger_id;
    $[144] = t61;
  } else {
    t61 = $[144];
  }
  let t62;
  if ($[145] !== t60 || $[146] !== t61) {
    t62 = <TeamPermission role="member">{t60}{t61}</TeamPermission>;
    $[145] = t60;
    $[146] = t61;
    $[147] = t62;
  } else {
    t62 = $[147];
  }
  let t63;
  if ($[148] !== t18 || $[149] !== t62) {
    t63 = <StyledViewLayout><StyledViewContent>{t18}{t62}</StyledViewContent></StyledViewLayout>;
    $[148] = t18;
    $[149] = t62;
    $[150] = t63;
  } else {
    t63 = $[150];
  }
  return t63;
};
export default IssueTriggerView;
function _temp() {
  return null;
}
function _temp2(t0) {
  const {
    isSubmitting: isSubmitting_0,
    isValid: isValid_0,
    dirty: dirty_0
  } = t0;
  return <Form><Prompt when={!isSubmitting_0 && dirty_0} message="Are you sure you want to quit without saving your work?" /><TextInput name="name" format={field_formats.slugify} placeholder="trigger-name" m={{
      b: 5
    }} mono={true} /><Button.Permission disabled={isSubmitting_0 || !isValid_0 || !dirty_0} submit={true} primary={true} icon="save">Save</Button.Permission></Form>;
}